module.exports = __webpack_public_path__ + "img/family_desc.c59abc7c.png";